import { useEffect, useState } from "react";
import { scrollTop } from "../../components/Helper";
import { useParams } from "react-router-dom";
import { fetchData, VERIFY_EMAIL } from "../../components/Service";

const VerifyEmail = () => {
  useEffect(() => {
    scrollTop();
  }, []);
  const { token } = useParams();

  const [message, setMessage] = useState("Verifying email...");
  const initFun = (data) => {
    fetchData(VERIFY_EMAIL, "POST", { token }, false, false, (res) => {
      console.log(res);
      setMessage(res?.message);
    });
  };

  useEffect(() => {
    initFun();
  }, []);

  return (
    <div className="col-lg-12">
      <div className="card overflow-hidden">
        <div className="card-header p-0 overflow-hidden">
          <div className="about-header">Email Verification </div>
        </div>
        <div className="card-body bg-white p-1">
          <div className="row">
            <div className="col-12">
              <h5 className="bg-light py-2">{message}</h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;
